import React from "react";
import { Box, Typography, Button } from "@mui/material";

import ProgressBar from "../Common/ProgressBar";
import StatusChip from "../Common/StatusChip";

export default function ProjectCard({
    title,
    type,
    progress,
    status,
    onOpen,
}) {
    return (
        <Box
                   sx={{
                       border: "1px solid #E8EDF5",
                       backgroundColor:"#F1F4F9",
                       borderRadius: "14px",
                       p: 2,
                       mb: 2,
                       "&:last-child": {
                           mb: 0,
                       },
                   }}
               >
            {/* Header */}
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    gap: 1,
                    mb: 1,
                }}
            >
                <Typography
                    sx={{
                        fontSize: 15,
                        fontWeight: 600,
                        color: "#1E293B",
                        lineHeight: 1.35,
                        flex: 1,
                    }}
                >
                    {title}
                </Typography>

                <StatusChip status={status} />
            </Box>

            {/* Project Type */}
           <Box
    sx={{
        display: "inline-flex",
        alignItems: "center",
        px: 1,
        py: 0.25,
        borderRadius: "6px",
        backgroundColor: "#EEF4FF",
        border: "1px solid #D7E6FF",
        width: "fit-content",
        mb: 1.5,
    }}
>
    <Typography
        sx={{
            fontSize: "11.25px",
            fontWeight: 400,
            color: "#2563EB",
            lineHeight: "15px",
        }}
    >
        {type}
    </Typography>
</Box>

            {/* Progress */}
            <Typography
                sx={{
                    fontSize: 12,
                    fontWeight: 600,
                    color: "#475569",
                    mb: 1,
                }}
            >
                {progress}% Complete
            </Typography>

            <ProgressBar value={progress} />

            <Box sx={{ flexGrow: 1 }} />

            {/* Button */}
          <Box
    sx={{
        display: "flex",
        justifyContent: "flex-end",
        mt: 2,
    }}
>
    <Button
        type="button"
        variant="outlined"
        
        onClick={onOpen}
        sx={{
            minWidth: 120,
            
            height: 34,
            borderRadius: "8px",
            borderColor: "#8B7BFF",
            color: "#6D5DF6",
            backgroundColor: "#fff",
            textTransform: "none",
            fontWeight: 500,
            fontSize: 13,

            "&:hover": {
                borderColor: "#6D5DF6",
                backgroundColor: "#F6F4FF",
            },
        }}
    >
        Go to Project
    </Button>
</Box>
        </Box>
    );
}